async function drinksDetailsAPI(id) {
  const resolve = await fetch(`https://www.thecocktaildb.com/api/json/v1/1/lookup.php?i=${id}`);
  const data = await resolve.json();
  const drink = data.drinks[0];
  return drink;
}

export default drinksDetailsAPI;
